const IdentificationTypes = Object.freeze({
    dni: 'DNI',
    cuit: 'CUIT',
    cuil: 'CUIL',
    le: 'LE',
    lc: 'LC',
    pasaporte: 'PASAPORTE'
})

export default IdentificationTypes


// WEBPACK FOOTER //
// ./src/constants/identification_types.js